import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PdfViewer from "../components/PdfViewer";
import { useTheme } from "../context/ThemeContext";

export default function NoteDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const { dark } = useTheme();

  useEffect(() => {
    fetch(`/api/posts/${slug}`)
      .then((r) => r.json())
      .then(setPost)
      .catch(() => {});
  }, [slug]);

  if (!post) return null;

  return (
    <div
      className={`min-h-screen transition-colors duration-300 ${
        dark ? "bg-gray-900" : "bg-gradient-to-b from-emerald-50 to-blue-50"
      }`}
    >
      <div className="max-w-6xl mx-auto p-6 grid gap-6 grid-cols-1 lg:grid-cols-[2fr_1fr]">
        {/* PDF viewer */}
        <div
          className={`rounded-2xl border overflow-hidden shadow-md ${
            dark ? "border-gray-700" : "border-gray-100"
          }`}
        >
          <PdfViewer src={`/api/posts/${post.slug}/pdf`} />
        </div>

        {/* Metadata sidebar */}
        <aside
          className={`p-6 rounded-2xl border shadow-md h-fit backdrop-blur-sm ${
            dark
              ? "bg-gray-800 border-gray-700 text-white"
              : "bg-white/85 border-gray-100 text-gray-900"
          }`}
        >
          {post.subject && (
            <span
              className={`inline-block text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-full mb-3 ${
                dark
                  ? "bg-emerald-900/40 text-emerald-400"
                  : "bg-emerald-100 text-emerald-700"
              }`}
            >
              {post.subject}
            </span>
          )}
          <h1 className="text-2xl font-bold leading-snug">{post.title}</h1>
          <div className={`text-sm mt-1 ${dark ? "text-gray-400" : "text-gray-400"}`}>
            {new Date(post.published_at).toLocaleDateString()}
          </div>
          <p
            className={`mt-4 leading-relaxed whitespace-pre-line ${
              dark ? "text-gray-300" : "text-gray-600"
            }`}
          >
            {post.summary}
          </p>
        </aside>
      </div>
    </div>
  );
}
